import { Component } from '@opten/compiler/metadata/component';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import {addClass} from '@opten/dom/add-class';
import {hasClass} from '@opten/dom/has-class';
import {removeClass} from '@opten/dom/remove-class';
import {getWindowScrollTop} from '@opten/dom/get-window-scroll-top';
import {parseCssUnit} from '@opten/number/parse-css-unit';
import {getCss} from '@opten/dom/get-css';

@Component({ className: 'js-header' })
export class Header implements OnInit {
    private _height: number;
    private _paddingTop: number | null = null;

    // prevent multiple resizings to add more height
    // if it's the same height as before!
    private _cachedHeight: number | null = null;

    // if we don't have a tangram,
    // we always want to show the shadow!
    private _handleBoxShadow: boolean = true;

    constructor(private element: HTMLElement) {
        this._handleBoxShadow = !hasClass(element, '--shadow');
    }

    onInit() {
        addClass(this.element, '--sticky');

        this._handleScroll();
        window.addEventListener('scroll', () => this._handleScroll());

        this._handleResize();
        window.addEventListener('resize', () => this._handleResize());
    }

    private _update() {
        if (this._paddingTop == null) {
            this._paddingTop = parseCssUnit(getCss(document.body, 'padding-top'));
        }

        document.body.style.paddingTop = `${this._paddingTop + this._height}px`;
    }

    private _handleScroll() {
        if (this._handleBoxShadow) {
            if (getWindowScrollTop() >= this._height) {
                addClass(this.element, '--shadow');
            } else {
                removeClass(this.element, '--shadow');
            }
        }
    }

    private _handleResize() {
        this._height = Math.round(this.element.getBoundingClientRect().height);

        if (this._cachedHeight !== this._height) {
            this._cachedHeight = this._height;
            this._update();
        }
    }
}
